import React, { useEffect, useState } from 'react';
import { FiArrowLeft, FiPlus, FiTrash2 } from 'react-icons/fi';
import CustomInput from '../../Components/CommonComponents/CustomInput';
import { toast, ToastContainer } from 'react-toastify';
import 'react-toastify/dist/ReactToastify.css';
import { getJwtToken, END_POINT } from '../../Redux/AdminReducer/action';
import { useNavigate, useParams } from 'react-router-dom';
import CustomSpinner from '../../Components/CommonComponents/CustomSpinner';
import axios from 'axios';

const fetchSingleItem = async (id) => {
  try {
    const result = await axios.get(`${END_POINT}/inventory/distributors/${id}`, {
      headers: {
        Authorization: getJwtToken(),
      },
    });
    return result;
  } catch (error) {
    toast.error(error?.response?.data || 'Something went wrong');
    console.log(error);

    toast.error('Something went wrong while fetching data');
  }
};

const createItem = async (data, navigate, setIsPorcessing) => {
  try {
    const result = await axios.post(`${END_POINT}/inventory/distributors`, data, {
      headers: {
        Authorization: getJwtToken(),
      },
    });
    let { data: id } = result?.data;
    setIsPorcessing(false);
    toast.success('Distributor Created Successfully');
    setTimeout(() => {
      navigate(`/main/inventory/Distributors`);
    }, 1000);
  } catch (error) {
    toast.error(error?.response?.data || 'Something went wrong');
    setIsPorcessing(false);
  }
};

const updateItem = async (data, setIsPorcessing) => {
  try {
    const result = await axios.put(`${END_POINT}/inventory/distributors/${data._id}`, data, {
      headers: {
        Authorization: getJwtToken(),
      },
    });
    toast.success('Details Updated');
    setTimeout(() => {
      window.location.reload();
    }, 500);
  } catch (error) {
    toast.error(error?.response?.data || 'Something went wrong');
    setIsPorcessing(false);
    toast.error('Failed To Updated');
  }
};

const AddCompanyItem = async (data, setIsPorcessing, d_id, setFormData) => {
  try {
    const result = await axios.post(`${END_POINT}/inventory/distributors/company/${d_id}`, data, {
      headers: {
        Authorization: getJwtToken(),
      },
    });
    setFormData((prev) => ({ ...prev, companies: [...prev.companies, result?.data] }));
    setIsPorcessing(false);
    toast.success('Item Added Successfully');
  } catch (error) {
    toast.error(error?.response?.data || 'Something went wrong');
    setIsPorcessing(false);
  }
};

const DeleteCompanyItem = async (setIsPorcessing, d_id, medicine_index, setFormData) => {
  try {
    const result = await axios.delete(`${END_POINT}/inventory/distributors/company/${d_id}/${medicine_index}`, {
      headers: {
        Authorization: getJwtToken(),
      },
    });
    setFormData((prev) => {
      const updatedCompanies = [...prev.companies];
      updatedCompanies.splice(medicine_index, 1);
      return { ...prev, companies: updatedCompanies };
    });
    setIsPorcessing(false);
  } catch (error) {
    toast.error(error?.response?.data || 'Something went wrong');
    setIsPorcessing(false);
  }
};

const updateCompanyItem = async (data, setIsPorcessing, d_id) => {
  try {
    const result = await axios.put(`${END_POINT}/inventory/distributors/${data._id}`, data, {
      headers: {
        Authorization: getJwtToken(),
      },
    });
    toast.success('Details Updated');
    setTimeout(() => {
      window.location.reload();
    }, 500);
  } catch (error) {
    toast.error(error?.response?.data || 'Something went wrong');
    setIsPorcessing(false);
    toast.error('Failed To Updated');
  }
};

const initialFormData = {
  companyName: '',
  address: '',
  ownerName: '',
  phone: '',
  email: '',
  gstNumber: '',
  companies: [],
};
const initialFormError = initialFormData;

export default function DistributorForm() {
  // define form state
  const [formData, setFormData] = useState();
  const [formData_List, setFormData_List] = useState();
  const [formError, setFormError] = useState(initialFormError);
  const navigate = useNavigate();
  const { inventory_item_id } = useParams();
  const [isProcessing, setIsPorcessing] = useState(false);

  useEffect(() => {
    if (inventory_item_id === 'addNew') {
      setFormData(initialFormData);
    } else {
      fetchSingleItem(inventory_item_id).then((e) => {
        setFormData(e?.data);
      });
    }
  }, [inventory_item_id]);

  // handel input change
  const handleInputChange = (event) => {
    const { name, value, type, checked } = event.target;
    setFormData({
      ...formData,
      [name]: value,
    });
  };

  const handleForm = () => {
    const trimmedFormData = { ...formData };
    let isValidInput = true;

    for (const key in trimmedFormData) {
      if (trimmedFormData?.hasOwnProperty(key)) {
        if (typeof trimmedFormData[key] === 'string') {
          trimmedFormData[key] = trimmedFormData[key].trim();
        }
      }
    }

    let updatedFormError = { formError };

    //  validate name
    // if (!trimmedFormData?.name) {
    //   updatedFormError.name = 'Name is required!';
    //   isValidInput = false;
    // }

    // // validate mobile
    // if (!trimmedFormData?.number) {
    //   updatedFormError.number = 'Phone number is required!';
    //   isValidInput = false;
    // } else if (!/^\d{10}$/.test(trimmedFormData?.number)) {
    //   updatedFormError.number = 'Invalid phone number, must be 10 digits!';
    //   isValidInput = false;
    // }

    // //  validate reference
    // if (!trimmedFormData?.reference) {
    //   updatedFormError.reference = 'reference is required!';
    //   isValidInput = false;
    // }

    // //  validate purposeOfEnquiry
    // if (!trimmedFormData?.purposeOfEnquiry) {
    //   updatedFormError.purposeOfEnquiry = 'Purpose Of Enquiry is required!';
    //   isValidInput = false;
    // }

    setFormError(updatedFormError);
    if (!isValidInput) {
      Object.keys(updatedFormError)?.map((f) => {
        toast.error(updatedFormError?.[f]);
      });
    }

    if (isValidInput) {
      setIsPorcessing(true);
      inventory_item_id == 'addNew' ? createItem(trimmedFormData, navigate, setIsPorcessing) : updateItem(trimmedFormData, setIsPorcessing);
    }
  };

  const isNew = inventory_item_id === 'addNew';

  return (
    <div className="min-h-screen w-full bg-slate-50 px-4 py-6 md:px-8">
      <div className="w-full">
        {/* Page header */}
        <div className="mb-6 flex flex-wrap items-center justify-between gap-3">
          <div className="flex items-center gap-3">
            <button
              type="button"
              onClick={() => navigate(-1)}
              aria-label="Go back"
              className="inline-flex h-9 w-9 items-center justify-center rounded-xl border border-slate-200 bg-white text-slate-600 shadow-sm transition hover:bg-slate-100 hover:text-slate-900"
            >
              <FiArrowLeft className="h-4 w-4" />
            </button>
            <div>
              <h1 className="text-xl font-semibold tracking-tight text-slate-900">
                {isNew ? 'Add Distributor' : 'Edit Distributor'}
              </h1>
              <p className="text-xs text-slate-500">
                {isNew ? 'Create a new distributor record.' : 'Update the distributor details and the companies they supply.'}
              </p>
            </div>
          </div>
        </div>

        {formData ? (
          <form
            onSubmit={(e) => {
              e.preventDefault();
              handleForm();
            }}
            className="space-y-6"
          >
            {/* Distributor details */}
            <section className="rounded-2xl border border-slate-200 bg-white shadow-sm">
              <div className="border-b border-slate-200 px-6 py-4">
                <h2 className="text-sm font-semibold tracking-tight text-slate-900">Distributor Details</h2>
              </div>
              <div className="grid grid-cols-1 gap-x-6 gap-y-4 px-6 py-5 sm:grid-cols-2 lg:grid-cols-3">
                <CustomInput label={'Company Name'} name={'companyName'} type={'text'} value={formData?.companyName || ''} onChange={handleInputChange} placeholder={'Enter Company Name'} error={formError.companyName} />
                <CustomInput label={'Owner Name'} name={'ownerName'} type={'text'} value={formData?.ownerName || ''} onChange={handleInputChange} placeholder={'Enter Owner Name'} error={formError.ownerName} />
                <CustomInput label={'Phone'} name={'phone'} type={'text'} value={formData?.phone || ''} onChange={handleInputChange} placeholder={'Enter Phone Number'} error={formError.phone} />
                <CustomInput label={'Email'} name={'email'} type={'text'} value={formData?.email || ''} onChange={handleInputChange} placeholder={'Enter Email Address'} error={formError.email} />
                <CustomInput label={'GST Number'} name={'gstNumber'} type={'text'} value={formData?.gstNumber || ''} onChange={handleInputChange} placeholder={'Enter GST Number'} error={formError.gstNumber} />
                <div className="sm:col-span-2 lg:col-span-3">
                  <CustomInput label={'Address'} name={'address'} type={'text'} value={formData?.address || ''} onChange={handleInputChange} placeholder={'Enter Address'} error={formError.address} />
                </div>
              </div>
            </section>

            {/* Companies supplied - only available once the distributor exists */}
            {!isNew && (
              <section className="rounded-2xl border border-slate-200 bg-white shadow-sm">
                <div className="border-b border-slate-200 px-6 py-4">
                  <h2 className="text-sm font-semibold tracking-tight text-slate-900">Companies Supplied</h2>
                  <p className="mt-0.5 text-xs text-slate-500">Brands this distributor can supply medicines for.</p>
                </div>

                <div className="px-6 py-5">
                  <div className="flex flex-wrap items-end gap-3">
                    <div className="w-full sm:w-72">
                      <CustomInput label={'Company Name'} name={'name'} type={'text'} value={formData_List?.name || ''} onChange={(e) => setFormData_List({ name: e.target.value })} placeholder={'Enter Company Name'} />
                    </div>
                    <button
                      type="button"
                      disabled={!formData_List?.name?.trim()}
                      className="inline-flex items-center gap-1.5 rounded-xl bg-sky-600 px-4 py-2 text-sm font-semibold text-white shadow-sm shadow-sky-600/30 transition hover:bg-sky-700 disabled:cursor-not-allowed disabled:opacity-50"
                      onClick={(e) => {
                        e.preventDefault();
                        AddCompanyItem(formData_List, setIsPorcessing, formData?._id, setFormData);
                        setFormData_List({ name: '' });
                      }}
                    >
                      <FiPlus className="h-4 w-4" />
                      Add
                    </button>
                  </div>

                  <div className="mt-5 overflow-hidden rounded-xl border border-slate-200">
                    <table className="w-full text-sm">
                      <thead className="bg-slate-50">
                        <tr>
                          <th className="px-4 py-2.5 text-left text-xs font-semibold uppercase tracking-wide text-slate-500">Company Name</th>
                          <th className="w-24 px-4 py-2.5 text-right text-xs font-semibold uppercase tracking-wide text-slate-500">Action</th>
                        </tr>
                      </thead>
                      <tbody className="divide-y divide-slate-100">
                        {formData?.companies?.length > 0 ? (
                          formData?.companies
                            .sort((a, b) => a?.company_index < b?.company_index)
                            .slice(0, 10)
                            ?.map((company, index) => (
                              <tr key={index} className="transition hover:bg-slate-50">
                                <td className="px-4 py-2.5 text-slate-800">{company.name}</td>
                                <td className="px-4 py-2.5 text-right">
                                  <button
                                    type="button"
                                    aria-label={`Remove ${company.name}`}
                                    className="inline-flex h-8 w-8 items-center justify-center rounded-lg border border-slate-200 text-slate-500 transition hover:border-rose-200 hover:bg-rose-50 hover:text-rose-600"
                                    onClick={(e) => {
                                      e.preventDefault();
                                      DeleteCompanyItem(setIsPorcessing, formData?._id, index, setFormData);
                                    }}
                                  >
                                    <FiTrash2 className="h-4 w-4" />
                                  </button>
                                </td>
                              </tr>
                            ))
                        ) : (
                          <tr>
                            <td colSpan={2} className="px-4 py-8 text-center text-sm text-slate-400">
                              No companies added yet.
                            </td>
                          </tr>
                        )}
                      </tbody>
                    </table>
                  </div>
                </div>
              </section>
            )}

            {/* Actions */}
            <div className="flex items-center justify-end gap-3 pb-4">
              <button
                type="button"
                onClick={() => navigate(-1)}
                className="rounded-xl border border-slate-300 bg-white px-4 py-2 text-sm font-medium text-slate-700 transition hover:bg-slate-100"
              >
                Cancel
              </button>
              <button
                type="submit"
                disabled={isProcessing}
                className="rounded-xl bg-sky-600 px-6 py-2 text-sm font-semibold text-white shadow-sm shadow-sky-600/30 transition hover:bg-sky-700 disabled:cursor-not-allowed disabled:opacity-60"
              >
                {isProcessing ? 'Please wait...' : isNew ? 'Submit' : 'Save Changes'}
              </button>
            </div>
          </form>
        ) : (
          <CustomSpinner />
        )}
      </div>

      <ToastContainer />
    </div>
  );
}
